(function () {
  if (window.__aeInit) return;
  window.__aeInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.ae-reveal:not(.ae-visible)');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ae-visible'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('ae-visible'); io.unobserve(e.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  /* #10 Héroe typewriter */
  function initTypewriter(root) {
    (root || document).querySelectorAll('[data-ae-rotador]').forEach(function (el) {
      if (el.dataset.aeInit) return;
      el.dataset.aeInit = '1';
      var palabras;
      try { palabras = JSON.parse(el.getAttribute('data-ae-rotador')); } catch (e) { return; }
      palabras = palabras.filter(function (p) { return p && p.trim(); });
      if (palabras.length < 2 || reduce) return;
      var i = 0, txt = palabras[0], borrando = true, pausa = 1800;
      function paso() {
        if (!document.body.contains(el)) return;
        var objetivo = palabras[i];
        if (borrando) {
          txt = txt.slice(0, -1);
          el.textContent = txt;
          if (!txt) { borrando = false; i = (i + 1) % palabras.length; return setTimeout(paso, 300); }
          return setTimeout(paso, 45);
        }
        objetivo = palabras[i];
        txt = objetivo.slice(0, txt.length + 1);
        el.textContent = txt;
        if (txt === objetivo) { borrando = true; return setTimeout(paso, pausa); }
        setTimeout(paso, 85);
      }
      setTimeout(paso, pausa);
    });
  }

  /* CTA magnético (sutil) */
  function initMagnetico(root) {
    if (reduce || window.matchMedia('(hover: none)').matches) return;
    (root || document).querySelectorAll('[data-ae-magnetico]').forEach(function (btn) {
      if (btn.dataset.aeInit) return;
      btn.dataset.aeInit = '1';
      btn.addEventListener('mousemove', function (ev) {
        var r = btn.getBoundingClientRect();
        var x = (ev.clientX - r.left - r.width / 2) / r.width;
        var y = (ev.clientY - r.top - r.height / 2) / r.height;
        btn.style.transform = 'translate(' + (x * 6).toFixed(1) + 'px,' + (y * 6).toFixed(1) + 'px)';
      });
      btn.addEventListener('mouseleave', function () { btn.style.transform = ''; });
    });
  }

  /* #17 Hotspots */
  function initHotspots(root) {
    (root || document).querySelectorAll('[data-ae-hotspots]').forEach(function (sec) {
      if (sec.dataset.aeInit) return;
      sec.dataset.aeInit = '1';
      var puntos = sec.querySelectorAll('.ae-hs__punto');
      var items = sec.querySelectorAll('.ae-hs__item');
      function activar(n) {
        puntos.forEach(function (p) { p.setAttribute('aria-expanded', p.dataset.n === n ? 'true' : 'false'); });
        items.forEach(function (it) { it.classList.toggle('ae-activo', it.dataset.n === n); });
      }
      puntos.forEach(function (p) {
        p.addEventListener('click', function () { activar(p.dataset.n); });
        p.addEventListener('mouseenter', function () { activar(p.dataset.n); });
      });
      items.forEach(function (it) {
        it.addEventListener('click', function () { activar(it.dataset.n); });
        it.addEventListener('mouseenter', function () { activar(it.dataset.n); });
      });
      if (puntos[0]) activar(puntos[0].dataset.n);
    });
  }

  /* #80 FAQ */
  function initFaq(root) {
    (root || document).querySelectorAll('.ae-faq__item').forEach(function (it) {
      if (it.dataset.aeInit) return;
      it.dataset.aeInit = '1';
      var btn = it.querySelector('.ae-faq__pregunta');
      btn.addEventListener('click', function () {
        var abierto = it.classList.toggle('ae-abierto');
        btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  /* Página de producto: galería, variantes y cantidad */
  function initProducto(root) {
    (root || document).querySelectorAll('[data-ae-producto]').forEach(function (pp) {
      if (pp.dataset.aeInit) return;
      pp.dataset.aeInit = '1';
      var principal = pp.querySelector('.ae-pp__principal img');
      var minis = pp.querySelectorAll('.ae-pp__mini');
      minis.forEach(function (m) {
        m.addEventListener('click', function () {
          if (!principal) return;
          principal.src = m.dataset.grande;
          principal.removeAttribute('srcset');
          minis.forEach(function (x) { x.setAttribute('aria-current', x === m ? 'true' : 'false'); });
        });
      });

      var cant = pp.querySelector('.ae-pp__cantidad input');
      pp.querySelectorAll('[data-ae-cant]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(cant.value, 10) || 1;
          v = Math.max(1, v + parseInt(b.dataset.aeCant, 10));
          cant.value = v;
        });
      });

      var datos = pp.querySelector('[data-ae-variantes]');
      if (!datos) return;
      var variantes;
      try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
      var inputId = pp.querySelector('input[name="id"]');
      var precio = pp.querySelector('[data-ae-precio]');
      var antes = pp.querySelector('[data-ae-antes]');
      var boton = pp.querySelector('.ae-pp__boton');
      var textoBoton = boton ? boton.dataset.texto : '';
      var textoAgotado = boton ? boton.dataset.agotado : '';
      var formato = pp.dataset.moneda || '${{amount}}';
      function dinero(c) {
        var n = (c / 100).toFixed(2);
        return formato.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.replace('.', ',')).replace(/\{\{\s*amount\s*\}\}/, n).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(c / 100));
      }
      function actualizar() {
        var sel = [];
        pp.querySelectorAll('.ae-pp__opcion').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          sel.push(c ? c.value : null);
        });
        var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
        if (!v) return;
        inputId.value = v.id;
        if (precio) precio.textContent = dinero(v.price);
        if (antes) {
          if (v.compare_at_price && v.compare_at_price > v.price) { antes.textContent = dinero(v.compare_at_price); antes.hidden = false; }
          else antes.hidden = true;
        }
        if (boton) {
          boton.disabled = !v.available;
          boton.querySelector('span').textContent = v.available ? textoBoton : textoAgotado;
        }
        if (v.featured_image && principal) {
          principal.src = v.featured_image.src;
          principal.removeAttribute('srcset');
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      pp.querySelectorAll('.ae-pp__opcion input').forEach(function (inp) { inp.addEventListener('change', actualizar); });
    });
  }

  /* #39 Carrusel de opiniones */
  function initCarrusel(root) {
    (root || document).querySelectorAll('[data-ae-carrusel]').forEach(function (car) {
      if (car.dataset.aeInit) return;
      car.dataset.aeInit = '1';
      var pista = car.querySelector('.ae-op__pista');
      var tarjetas = car.querySelectorAll('.ae-op__tarjeta');
      var puntos = car.querySelector('.ae-op__puntos');
      if (!pista || tarjetas.length < 2) return;
      function paso() { return tarjetas[1].offsetLeft - tarjetas[0].offsetLeft; }
      function paginas() { return Math.max(1, Math.round((pista.scrollWidth - pista.clientWidth) / paso()) + 1); }
      function actual() { return Math.round(pista.scrollLeft / paso()); }
      function pintarPuntos() {
        if (!puntos) return;
        var n = paginas(), a = Math.min(actual(), n - 1), html = '';
        for (var i = 0; i < n; i++) html += '<span class="ae-op__punto' + (i === a ? ' ae-activo' : '') + '"></span>';
        puntos.innerHTML = html;
      }
      function ir(i) {
        var n = paginas();
        if (i >= n) i = 0;
        if (i < 0) i = n - 1;
        pista.scrollTo({ left: i * paso(), behavior: reduce ? 'auto' : 'smooth' });
      }
      car.querySelectorAll('.ae-op__flecha').forEach(function (b) {
        b.addEventListener('click', function () { ir(actual() + parseInt(b.dataset.dir, 10)); reiniciar(); });
      });
      var t = null;
      pista.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(pintarPuntos, 80); }, { passive: true });
      window.addEventListener('resize', pintarPuntos);
      pintarPuntos();

      var timer = null, pausado = false;
      var auto = car.dataset.autoplay === 'true' && !reduce;
      var ms = (parseInt(car.dataset.segundos, 10) || 5) * 1000;
      function reiniciar() {
        clearInterval(timer);
        if (!auto) return;
        timer = setInterval(function () {
          if (pausado || !document.body.contains(car)) return;
          ir(actual() + 1);
        }, ms);
      }
      car.addEventListener('mouseenter', function () { pausado = true; });
      car.addEventListener('mouseleave', function () { pausado = false; });
      car.addEventListener('focusin', function () { pausado = true; });
      car.addEventListener('focusout', function () { pausado = false; });
      pista.addEventListener('touchstart', function () { pausado = true; }, { passive: true });
      pista.addEventListener('touchend', function () { setTimeout(function () { pausado = false; }, 4000); }, { passive: true });
      reiniciar();
    });
  }

  function initTodo(ev) {
    var root = ev && ev.target && ev.target.nodeType === 1 ? ev.target : document;
    initReveal(root);
    initTypewriter(root);
    initMagnetico(root);
    initHotspots(root);
    initFaq(root);
    initProducto(root);
    initCarrusel(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo);
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
